// extracted by mini-css-extract-plugin
module.exports = {"List":"BillList_List__P2_O2","Empty":"BillList_Empty__5EsA8"};